'use client'

import { useEffect, useState } from 'react'

const COOKIE_NAME = 'demo_banner_dismissed'

function isDismissed(): boolean {
  return document.cookie.split('; ').some((c) => c === `${COOKIE_NAME}=1`)
}

function saveDismissed() {
  document.cookie = `${COOKIE_NAME}=1; path=/; SameSite=Lax`
}

export function DemoBanner({ enabled }: { enabled: boolean }) {
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (isDismissed()) {
      setDismissed(true)
    }
  }, [])

  if (!enabled || dismissed) return null

  function handleDismiss() {
    saveDismissed()
    setDismissed(true)
  }

  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center bg-black/60 pointer-events-none">
      <button
        onClick={handleDismiss}
        className="absolute top-4 right-4 pointer-events-auto text-white/70 hover:text-white leading-none"
        aria-label="Close demo banner"
        style={{ fontSize: '1.5rem', background: 'none', border: 'none', cursor: 'pointer' }}
      >
        ✕
      </button>
      <span
        className="text-white font-bold select-none pointer-events-none"
        style={{ fontSize: 'clamp(6rem, 20vw, 20rem)', opacity: 0.1, letterSpacing: '0.15em' }}
      >
        DEMO
      </span>
    </div>
  )
}
